export interface Sale extends CreateSale {
  id: string;
  accountId: string;
  userId: string;
}

export interface CreateSale {
  date: string;
  guests: number;
  income: number;
  portionPrice: number;
  portions: number;
  productionCost: number;
  productionWeight: number;
}

export interface SalesState {
  sales: Sale[];
  yearlySales: Sale[];
  // mainly for tracking change, used on dashboard to refetch data if old guest registration flow is used
  lastSale?: Sale;
}

export enum SalesActionTypes {
  SUBMIT_SALES = 'esmiley/sales/SUBMIT_SALES',
  GET_SALES = 'esmiley/sales/GET_SALES',
  GET_YEARLY_SALES = 'esmiley/sales/GET_YEARLY_SALES'
}

type GetSalesAction = {
  type: typeof SalesActionTypes.GET_SALES;
  payload: Sale[];
};

type GetYearlySalesAction = {
  type: typeof SalesActionTypes.GET_YEARLY_SALES;
  payload: Sale[];
};

type SubmitSaleAction = {
  type: typeof SalesActionTypes.SUBMIT_SALES;
  payload: Sale;
};

export type SalesActions = GetSalesAction | GetYearlySalesAction | SubmitSaleAction;
